(() => {
  const values = new Map();
  const key = el => `${location.pathname}:${el.name}`;
  const remember = event => {
    const el = event.target;
    if (el.matches('.htw-personalization input, .htw-personalization textarea, .htw-personalization select')) values.set(key(el), el.value);
  };
  document.addEventListener('input', remember, true);
  document.addEventListener('change', remember, true);
  const restore = () => {
    document.querySelectorAll('.htw-personalization input, .htw-personalization textarea, .htw-personalization select').forEach(el => {
      if (values.has(key(el)) && el.value !== values.get(key(el))) el.value = values.get(key(el));
    });
  };
  new MutationObserver(restore).observe(document.body, {childList: true, subtree: true});
})();
